import * as React from 'react';
import IconProps from '@shared/icons/types/IconProps';

function SvgFiMessageSquare({ size, color, ...props }: IconProps): React.JSX.Element {
	const finalSize = size !== undefined ? size : 16;
	const finalColor = color !== undefined ? color : 'currentColor';
	return (
		<svg
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 18 18"
			width={finalSize}
			height={finalSize}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.16699 2.33268C2.94598 2.33268 2.73402 2.42048 2.57774 2.57676C2.42146 2.73304 2.33366 2.945 2.33366 3.16602V14.4875L4.2444 12.5768C4.40068 12.4205 4.61264 12.3327 4.83366 12.3327H14.8337C15.0547 12.3327 15.2666 12.2449 15.4229 12.0886C15.5792 11.9323 15.667 11.7204 15.667 11.4993V3.16602C15.667 2.945 15.5792 2.73304 15.4229 2.57676C15.2666 2.42048 15.0547 2.33268 14.8337 2.33268H3.16699ZM1.39923 1.39825C1.86807 0.929408 2.50395 0.666016 3.16699 0.666016H14.8337C15.4967 0.666016 16.1326 0.929408 16.6014 1.39825C17.0703 1.86709 17.3337 2.50297 17.3337 3.16602V11.4993C17.3337 12.1624 17.0703 12.7983 16.6014 13.2671C16.1326 13.736 15.4967 13.9993 14.8337 13.9993H5.17884L2.08958 17.0886C1.85125 17.3269 1.49282 17.3982 1.18142 17.2692C0.870027 17.1403 0.666992 16.8364 0.666992 16.4993V3.16602C0.666992 2.50297 0.930384 1.86709 1.39923 1.39825Z"
				fill={finalColor}
			/>
		</svg>
	);
}
export default SvgFiMessageSquare;
